<template>
	<div class="searchLog">
		<form @submit.prevent="handleSearch">
			<div class="searchLog__date">
				<select-input
					ref="searchLog"
					:select-list="dateList"
					:defaultSelectValue="dateType"
					class="searchLog__select"
					@change="getSelection"
				/>
				<button class="btn blue" type="submit">검색</button>
				<button class="btn" type="button" @click="init">초기화</button>
			</div>
		</form>
		<p class="searchLog__total">
			{{ searchLogList.length.toLocaleString() }}개 검색됨
		</p>
		<table class="table-main">
			<thead>
				<tr>
					<th class="searchLog__num">번호</th>
					<th class="searchLog__keyword">검색어</th>
					<th class="searchLog__search">검색 횟수</th>
					<th class="searchLog__button">검색 결과</th>
					<th class="searchLog__button">삭제</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(list, index) in searchLogList" :key="index">
					<td class="searchLog__num">{{ index + 1 }}</td>
					<td class="searchLog__keyword">{{ list.keyword }}</td>
					<td class="searchLog__search">{{ list.searchCount }}</td>
					<td class="searchLog__button">
						<a
							class="btn blue search__result"
							:href="`https://www.glowpick.com/searches/keywords?search=${list.keyword}`"
							target="_blank"
							>보기</a
						>
					</td>
					<td class="searchLog__button">
						<button
							class="btn red"
							@click="deleteSearchLog(list.keyword)"
						>
							삭제
						</button>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>
<script>
	import ManagingBox from '../../components/layout/ManagingBox.vue';
	import ManagingSection from '../../components/layout/ManagingSection.vue';
	import SelectInput from '../../components/SelectInput.vue';
	import moment from 'moment';

	export default {
		components: { ManagingSection, ManagingBox, SelectInput },
		data() {
			return {
				searchLogList: [],
				dateList: [
					{ value: '90', name: '최근 3개월' },
					{ value: '180', name: '최근 6개월' },
					{ value: 'all', name: '누적' },
				],
				dateType: '90',
				keyword: '',
			};
		},
		created() {
			this.getSearchLog();
		},
		watch: {
			dateType() {
				if (!this.keyword) this.getSearchLog();
			},
		},
		methods: {
			async getSearchLog() {
				try {
					let params = new URLSearchParams();

					if (this.keyword) params.append('keyword', this.keyword);

					const startAt = this.getStartDate();
					const endAt = this.getEndDate();

					if (startAt) {
						params.append('startAt', startAt);
					}
					if (endAt) {
						params.append('endAt', endAt);
					}

					const queryString = params.toString();
					const { data } = await this.$axiosAdmin2.get(
						`/api/operation/statistic/search-log/list?${queryString}`
					);
					this.searchLogList = data;
				} catch (error) {
					console.error(error);
					alert(
						'검색 로그를 불러오는데 실패했습니다. 지속적인 문제 발생시 개발팀에 문의주세요.'
					);
				}
			},
			async deleteSearchLog(idSearchLog) {
				try {
					if (!confirm('정말 삭제하시겠습니까?')) return;
					await this.$axiosAdmin2.delete(
						`/api/operation/statistic/search-log?keyword=${idSearchLog}`
					);
					alert('삭제되었습니다.');
					this.getSearchLog();
				} catch (error) {
					console.error(error);
					alert(
						'삭제에 실패했습니다. 지속적인 문제 발생시 개발팀에 문의주세요.'
					);
				}
			},
			getStartDate() {
				const today = moment();
				let startDate;

				if (this.dateType === '90') {
					startDate = today.subtract(3, 'months');
				} else if (this.dateType === '180') {
					startDate = today.subtract(6, 'months');
				} else {
					startDate = '';
				}

				return startDate.valueOf();
			},
			getEndDate() {
				const today = moment();
				return today.valueOf();
			},
			getSelection({ select, input }) {
				this.dateType = select;
				this.keyword = input;
			},
			handleSearch() {
				this.getSearchLog();
			},
			init() {
				this.dateType = 'all';
				this.keyword = '';
				this.$refs.searchLog.init();
			},
		},
	};
</script>
<style lang="scss" scoped>
	.searchLog {
		table {
			margin-top: 30px;
		}

		&__total {
			margin-top: 20px;
			font-size: 16px;
			color: #666;
		}

		&__result {
			cursor: pointer;
		}

		&__date {
			margin-top: 20px;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			gap: 10px;
		}

		&__select {
			width: 500px;
		}

		.searchLog__num {
			width: 10%;
		}
		.searchLog__keyword {
			width: 30%;
		}
		.searchLog__search {
			width: 10%;
		}
		.searchLog__button {
			width: 10%;
		}
	}
</style>
